<template>
  <div class="contract-documents">
    <section-title
      class="mt-4 mb-3"
      has-line
      title="Documentos Contrato"
      title-class="section-title-info"
    />

    <div v-for="(contract, idx) of page.data" :key="idx">
      <contract-document-container
        :contract-document="contract"
        :proposal-request-id="proposalRequestId"
        :show-submit="showSubmit"
        @on-file-upload="searchDocuments"
        @on-status-change="onStatusChangeHandler"
      />
    </div>

    <pagination
      v-if="page.totalItemCount > pageSize"
      :data="page"
      :page-size="pageSize"
      @pagination-go-page="setCurrentPage"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import ContractDocumentContainer from '@/views/provider/proposalHistory/components/ContractDocumentContainer.vue';
import SectionTitle from 'SectionTitle';
import {
  getProposalDocuments,
  submitProposalContractDocument,
} from '@/modules/serviceProposalHistory/api';
import Pagination from 'pagination';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'ContractDocumentsTab',
  components: {
    ContractDocumentContainer,
    SectionTitle,
    Pagination,
  },
  mixins: [alertMixin],
  props: {
    proposalRequestId: {
      type: Number,
      default: () => 0,
    },
    bus: {
      type: Vue,
      default: () => new Vue(),
    },
    showSubmit: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    page: {
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
      data: [],
    },
    pageSize: 20,
  }),
  created() {
    this.bus.$on('submitContractDocument', async () => {
      await this.submitContractDocument(this.proposalRequestId);
    });
  },
  async mounted() {
    this.$emit('validateStatus', true);
    await this.setCurrentPage(1);
  },
  methods: {
    async submitContractDocument() {
      const answer = await this.ShowCancelModal(
        'Certificación de Documentos de Contrato',
        'Certifico que los documentos sometidos son copia fiel y exacta de los documentos originales',
        'Si',
        'No'
      );

      if (!answer) {
        return;
      }

      try {
        await submitProposalContractDocument(this.proposalRequestId);
        await this.onStatusChangeHandler();

        this.ShowToast(
          'Alerta',
          'Documentos sometidos exitosamente.',
          'success',
          5000
        );

        this.$emit('validateStatus', true);
      } catch (err) {
        this.ShowToast(
          'Alerta',
          'Se requieren todos los documentos para poder someter',
          'error',
          5000
        );
      }
    },
    async onStatusChangeHandler() {
      await this.searchDocuments();
    },
    async setCurrentPage(pageNumber) {
      this.page.currentPage = pageNumber;
      await this.searchDocuments();
    },
    async searchDocuments() {
      const params = {
        pageIndex: this.page.currentPage,
        pageSize: this.pageSize,
      };

      try {
        const res = await getProposalDocuments(this.proposalRequestId, params);

        this.page = {
          count: res.data.count,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          data: res.data.data,
          currentPage: res.data.currentPage,
        };

        this.$emit('validateStatus');
      } catch {
        this.ShowToast(
          'Alerta',
          'Error al recuperar los documentos',
          'error',
          5000
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
